import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, ChangeDetectorRef, Component, input, InputSignal, OnChanges } from '@angular/core';
import { AnimationProp, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { IconDefinition as FaIconDefinition, RotateProp } from '@fortawesome/fontawesome-svg-core';
import { ComponentsIconsStyle, IconDefinition, IconName } from '@libs/shared/models';
import { Subject } from 'rxjs';
import { IconLoaderService } from '../../services';

@Component({
  selector: 'ui-icon',
  styleUrls: ['./icon.component.scss'],
  templateUrl: './icon.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    FontAwesomeModule,
    AsyncPipe,
  ],
})
export class IconComponent implements OnChanges {
  public faStyle: InputSignal<ComponentsIconsStyle> = input.required();
  public faName: InputSignal<IconName> = input.required();
  public animation: InputSignal<AnimationProp | undefined> = input<AnimationProp | undefined>();
  public rotate: InputSignal<RotateProp | undefined> = input<RotateProp | undefined>();
  public title: InputSignal<string | undefined> = input<string | undefined>();

  public icon$: Subject<FaIconDefinition | undefined> = new Subject();

  public constructor(
    private readonly iconLoader: IconLoaderService,
    private readonly changeDetector: ChangeDetectorRef,
  ) {
  }

  public ngOnChanges(): void {
    void this.iconLoader.load(this.faStyle(), this.faName())
      .then(this.updateIcon.bind(this));
  }

  private updateIcon(icon: IconDefinition | undefined): void {
    this.icon$.next(icon as FaIconDefinition);
    this.changeDetector.detectChanges();
  }
}
